import { useEffect } from "react";

import { Outlet, useLocation } from "react-router-dom";

import { gtmUrl, isLocalEnvironment } from "../../config";
import { LoadScript } from "../../lib/LoadScript";

export const LoadGTMLayout = () => {
  const { search } = useLocation();

  useEffect(() => {
    const isInApp = new URLSearchParams(search).get("inapp") === "true";
    if (!isInApp && !isLocalEnvironment) {
      LoadScript({
        id: "tagmanager",
        url: gtmUrl,
        async: true,
      });
    } else if (isLocalEnvironment) {
      console.info(`%cGTM script not loaded`, "color: #a0a000; font-weight: bold;");
    }
  }, [search]);

  return <Outlet />;
};
